<template>
  <li class="context__menu-item">
    <!--
      El `title` no es adorno: este interruptor cambia la PIEL —colores, letra,
      formas— y nada mas. El alto de fila y la casilla siempre visible viven en
      constantes de JavaScript que el scroll virtual usa para calcular la
      posicion de cada fila, horneadas en la imagen; no se pueden cambiar en
      caliente. Sin decirlo, "Aspecto: Clásico" promete devolver la aplicacion
      tal cual y no lo hace, y el que lo prueba cree que esta roto.
    -->
    <a
      class="context__menu-item-link"
      title="Cambia colores, tipografía y formas. El alto de fila y la casilla de selección vienen de la imagen y no cambian con esto."
      @click.stop="alternar()"
    >
      <i class="context__menu-item-icon iconoir-color-picker"></i>
      Aspecto: {{ etiqueta }}
    </a>
  </li>
</template>

<script>
import { leerPiel, guardarPiel, PIELES } from '@extras_mg/tema'

/**
 * Interruptor de piel en el menu de usuario, al lado del de tema.
 *
 * La piel "Monday" es la de fabrica en esta instancia: el equipo viene de
 * Monday y la idea es que la herramienta no se sienta ajena. Este interruptor
 * existe para poder apagarla —y ver Baserow tal como viene— sin tocar nada del
 * servidor; sirve, sobre todo, para saber si algo raro es culpa de la piel.
 *
 * Es aparte del tema a proposito: la piel cambia formas, medidas y tipografia;
 * el tema decide claro u oscuro. Son dos preguntas distintas.
 */
export default {
  name: 'SelectorDePiel',
  data() {
    return { piel: 'monday' }
  },
  computed: {
    etiqueta() {
      // Se guarda como 'baserow' (y así la lee la hoja de estilos), pero a la
      // vista se llama "Clásico": marca propia, 2026-09-29.
      return this.piel === 'monday' ? 'Monday' : 'Clásico'
    },
  },
  mounted() {
    // En mounted y no en data(): data() tambien corre en el servidor, donde no
    // hay localStorage.
    this.piel = leerPiel()
  },
  methods: {
    alternar() {
      this.piel = PIELES[(PIELES.indexOf(this.piel) + 1) % PIELES.length]
      guardarPiel(this.piel)
    },
  },
}
</script>
